import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["link", "comment", "icon", "loose", "state", "size", "_enableIconPadding", "component", "onMouseEnter", "onMouseLeave", "isMobile", "href", "disabled", "rel", "isNotSelectable"];

var _class, _class2, _temp; // TODO: Enable this rule in functional components.

/* eslint-disable @typescript-eslint/no-unused-vars */


import React from 'react';
import PropTypes from 'prop-types';
import { globalObject, isBrowser } from '@skbkontur/global-object';
import { isExternalLink, isFunction, isNonNullable, isReactUIComponent } from "../../../lib/utils";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { rootNode } from "../../../lib/rootNode";
import { MenuContext } from "../../../internal/Menu/MenuContext";
import { getFullReactUIFlagsContext, ReactUIFeatureFlagsContext } from "../../../lib/featureFlagsContext";
import { getVisualStateDataAttributes } from "../../../internal/CommonWrapper/getVisualStateDataAttributes";
import { styles } from "../MenuItem.styles";
/**
 * @deprecated use SizeProp
 */

export var MenuItemDataTids = {
  root: 'MenuItem__root',
  content: 'MenuItem__content',
  comment: 'MenuItem__comment'
};
/**
 *
 * `MenuItem` - это вложенный компонент, задающий базовые стили для элемента меню и позволяющий навигироваться по элементам меню с помощью клавиатуры.
 *
 * Сущности в которых может быть использован `MenuItem`: [DropdownMenu](#/Components/DropdownMenu), [Kebab](#/Components/Kebab), [TooltipMenu](#/Components/TooltipMenu) и [Select](#/Components/Select).
 */

export var MenuItem = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      iconOffsetTop: 0,
      highlighted: false
    };
    _this.mouseEntered = false;
    _this.rootRef = null;
    _this.contentRef = /*#__PURE__*/React.createRef();

    _this.highlight = function () {
      _this.setState({
        highlighted: true
      });
    };

    _this.unhighlight = function () {
      _this.setState({
        highlighted: false
      });
    };

    _this.select = function (event) {
      _this.handleClick(event);
    };

    _this.isEnabled = function () {
      return !_this.props.disabled;
    };

    _this.navigate = function () {
      if (!_this.props.href) {
        return;
      }

      if (_this.props.target) {
        window.open(_this.props.href, _this.props.target);
      } else {
        location.href = _this.props.href;
      }
    };

    _this.renderMain = function (props) {
      var _cx2, _cx3, _cx4;

      var link = props.link,
          comment = props.comment,
          icon = props.icon,
          loose = props.loose,
          state = props.state,
          size = props.size,
          _enableIconPadding = props._enableIconPadding,
          component = props.component,
          onMouseEnter = props.onMouseEnter,
          onMouseLeave = props.onMouseLeave,
          isMobile = props.isMobile,
          href = props.href,
          disabled = props.disabled,
          _props$rel = props.rel,
          rel = _props$rel === void 0 ? _this.props.href && isExternalLink(_this.props.href) ? 'noopener noreferrer' : _this.props.rel : _props$rel,
          isNotSelectable = props.isNotSelectable,
          rest = _objectWithoutPropertiesLoose(props, _excluded);

      var iconElement = null;

      if (icon) {
        var _cx;

        iconElement = /*#__PURE__*/React.createElement("div", {
          style: {
            top: _this.state.iconOffsetTop
          },
          className: cx((_cx = {}, _cx[styles.icon(_this.theme)] = true, _cx[_this.getIconSizeClassName()] = true, _cx))
        }, icon);
      }

      var className = cx((_cx2 = {}, _cx2[styles.root(_this.theme)] = true, _cx2[_this.getRootSizeClassName()] = true, _cx2[styles.rootMobile(_this.theme)] = isMobile, _cx2[styles.loose()] = !!loose, _cx2[styles.hover(_this.theme)] = _this.isHover, _cx2[styles.selected(_this.theme)] = _this.isSelected, _cx2[styles.link(_this.theme)] = !!link, _cx2[_this.getWithIconSizeClassName()] = Boolean(iconElement) || !!_enableIconPadding || _this.context.enableIconPadding, _cx2[styles.disabled(_this.theme)] = !!_this.props.disabled, _cx2));
      var children = _this.props.children;
      var content = children;

      if (isFunction(children)) {
        content = children(_this.props.state);
      }

      var Component = _this.getComponent();

      return /*#__PURE__*/React.createElement(Component, _extends({
        ref: _this.setRootRef,
        "data-tid": MenuItemDataTids.root
      }, rest, {
        disabled: disabled,
        state: _this.activeState,
        onMouseOver: _this.handleMouseEnterFix,
        onMouseLeave: _this.handleMouseLeave,
        onClick: _this.handleClick,
        className: className,
        href: href,
        rel: href ? rel : undefined,
        tabIndex: -1
      }), iconElement, /*#__PURE__*/React.createElement("span", {
        className: cx((_cx3 = {}, _cx3[styles.mobileContentWithIcon()] = isMobile && isNonNullable(icon), _cx3)),
        ref: _this.contentRef,
        "data-tid": MenuItemDataTids.content
      }, content), _this.props.comment && /*#__PURE__*/React.createElement("div", {
        "data-tid": MenuItemDataTids.comment,
        className: cx((_cx4 = {}, _cx4[styles.comment(_this.theme)] = true, _cx4[styles.commentHover(_this.theme)] = _this.isHover, _cx4))
      }, comment));
    };

    _this.handleMouseEnterFix = function (e) {
      if (!_this.mouseEntered) {
        var _this$context$navigat;

        _this.mouseEntered = true;
        _this.props.onMouseEnter == null ? void 0 : _this.props.onMouseEnter(e);
        _this.menuItemsAtAnyLevel && !_this.props.isNotSelectable && ((_this$context$navigat = _this.context.navigation) == null ? void 0 : _this$context$navigat.highlight(_assertThisInitialized(_this)));
      }
    };

    _this.handleMouseLeave = function (e) {
      var _this$context$navigat2;

      _this.mouseEntered = false;
      _this.props.onMouseLeave == null ? void 0 : _this.props.onMouseLeave(e);
      _this.menuItemsAtAnyLevel && !_this.props.isNotSelectable && ((_this$context$navigat2 = _this.context.navigation) == null ? void 0 : _this$context$navigat2.unhighlight());
    };

    _this.handleClick = function (e) {
      if (_this.props.isNotSelectable) {
        return;
      }

      _this.props.onClick == null ? void 0 : _this.props.onClick(e);

      if (_this.menuItemsAtAnyLevel) {
        _this.context.onItemClick == null ? void 0 : _this.context.onItemClick(e);
      }
    };

    _this.setRootRef = function (element) {
      _this.rootRef = element;
    };

    _this.getComponent = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          component = _this$props.component,
          href = _this$props.href;

      if (component) {
        return component;
      }

      if (disabled) {
        return 'button';
      }

      if (href) {
        return 'a';
      }

      return 'button';
    };

    _this.hasIconAmongItems = function () {
      var _this$context$navigat3;

      return Boolean((_this$context$navigat3 = _this.context.navigation) == null ? void 0 : _this$context$navigat3.items.some(function (item) {
        return item.props.icon;
      }));
    };

    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ReactUIFeatureFlagsContext.Consumer, null, function (flags) {
      _this2.menuItemsAtAnyLevel = getFullReactUIFlagsContext(flags).menuItemsAtAnyLevel;
      return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
        _this2.theme = theme;
        return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
          rootNodeRef: _this2.setRootNode
        }, getVisualStateDataAttributes({
          hover: _this2.isHover,
          selected: _this2.isSelected
        }), _this2.props), _this2.renderMain);
      });
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.rootRef && isBrowser(globalObject)) {
      this.setState({
        iconOffsetTop: globalObject.getComputedStyle(this.rootRef).getPropertyValue('padding-top')
      });
    }

    if (this.contentRef.current && this.menuItemsAtAnyLevel && !this.props.isNotSelectable) {
      var _this$context$navigat4;

      (_this$context$navigat4 = this.context.navigation) == null ? void 0 : _this$context$navigat4.add(this.contentRef.current, this);
    }

    if (this.props.icon && this.menuItemsAtAnyLevel) {
      var _this$context$setEnab, _this$context;

      (_this$context$setEnab = (_this$context = this.context).setEnableIconPadding) == null ? void 0 : _this$context$setEnab.call(_this$context, true);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.contentRef.current && this.menuItemsAtAnyLevel) {
      var _this$context$navigat5, _this$context$setEnab2, _this$context2;

      !this.props.isNotSelectable && ((_this$context$navigat5 = this.context.navigation) == null ? void 0 : _this$context$navigat5.remove(this.contentRef.current));
      (_this$context$setEnab2 = (_this$context2 = this.context).setEnableIconPadding) == null ? void 0 : _this$context$setEnab2.call(_this$context2, this.hasIconAmongItems());
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.icon !== this.props.icon) {
      var _this$context$setEnab3, _this$context3;

      (_this$context$setEnab3 = (_this$context3 = this.context).setEnableIconPadding) == null ? void 0 : _this$context$setEnab3.call(_this$context3, !!this.props.icon || this.hasIconAmongItems());
    }

    if (this.contentRef.current && this.menuItemsAtAnyLevel && prevProps.isNotSelectable !== this.props.isNotSelectable) {
      if (this.props.isNotSelectable) {
        var _this$context$navigat6;

        this.unhighlight();
        (_this$context$navigat6 = this.context.navigation) == null ? void 0 : _this$context$navigat6.remove(this.contentRef.current);
      } else {
        var _this$context$navigat7;

        (_this$context$navigat7 = this.context.navigation) == null ? void 0 : _this$context$navigat7.add(this.contentRef.current, this);
      }
    }
  };

  _proto.getRootSizeClassName = function getRootSizeClassName() {
    switch (this.props.size) {
      case 'large':
        return styles.rootLarge(this.theme);

      case 'medium':
        return styles.rootMedium(this.theme);

      case 'small':
      default:
        return styles.rootSmall(this.theme);
    }
  };

  _proto.getIconSizeClassName = function getIconSizeClassName() {
    switch (this.props.size) {
      case 'large':
        return styles.iconLarge(this.theme);

      case 'medium':
        return styles.iconMedium(this.theme);

      case 'small':
      default:
        return styles.iconSmall(this.theme);
    }
  };

  _proto.getWithIconSizeClassName = function getWithIconSizeClassName() {
    switch (this.props.size) {
      case 'large':
        return styles.withIconLarge(this.theme);

      case 'medium':
        return styles.withIconMedium(this.theme);

      case 'small':
      default:
        return styles.withIconSmall(this.theme);
    }
  };

  _createClass(MenuItem, [{
    key: "activeState",
    get: function get() {
      return this.state.highlighted ? 'hover' : this.props.state;
    }
  }, {
    key: "isHover",
    get: function get() {
      return (this.state.highlighted || this.props.state === 'hover') && !this.props.disabled;
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this.props.state === 'selected' && !this.state.highlighted;
    } // https://github.com/facebook/react/issues/10109
    // Mouseenter event not triggered when cursor moves from disabled button

  }]);

  return MenuItem;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'MenuItem', _class2.displayName = 'MenuItem', _class2.__MENU_ITEM__ = true, _class2.propTypes = {
  comment: PropTypes.node,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.node,
  loose: PropTypes.bool,
  state: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string
}, _class2.contextType = MenuContext, _temp)) || _class;
export var isMenuItem = isReactUIComponent('MenuItem');